import React, { useEffect } from "react"
import { loadEnvVars } from "./utils/loadEnvVars"
import { POSTE_LOGIN_ROUTES, PosteLoginRoutes } from "./consts/routes"

export const ExternalRedirectPoste: React.FC<{ connection: PosteLoginRoutes }> = ({ connection }) => {
  const { redirectPosteBpiol, redirectPosteBusiness } = loadEnvVars()

  useEffect(() => {
    switch (connection) {
      // the variables are for prd env , TODO need fix it
      case POSTE_LOGIN_ROUTES.posteLoginBpiol:
        window.location.href =
          "https://login.bancacfplus.it/authorize?client_id=dqfK9PWM3UdjiWr5OMTtJJDtr5tRjDDg&response_type=code&connection=poste-bpiol&prompt=login&scope=openid%20profile&redirect_uri=https://clienti.bancacfplus.it"
        break
      case POSTE_LOGIN_ROUTES.posteLoginBusiness:
        window.location.href =
          "https://login.bancacfplus.it/authorize?client_id=dqfK9PWM3UdjiWr5OMTtJJDtr5tRjDDg&response_type=code&connection=poste-business&prompt=login&scope=openid%20profile&redirect_uri=https://clienti.bancacfplus.it"
        break
    }
  }, [])

  return <></>
}
